document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("recipe-ingredient-counter")) {
    class RecipeIngredientCounter extends HTMLElement {
      constructor() {
        super();
        this.counterElement = this.querySelector(
          "#recipe-ingredient-counter--qty"
        );
        this.increaseButton = this.querySelector("#increase");
        this.decreaseButton = this.querySelector("#decrease");
        this.ingredientListElement = this.querySelector(
          "#ingredients .metafield-rich_text_field"
        );
        this.tabContentElement = this.querySelector(".tab-content"); // Mobile tab content

        const quantityText = this.counterElement.textContent.trim();
        this.counterNumber = parseInt(
          quantityText.match(/\d+/)?.[0] || "1",
          10
        );
        this.textSuffix = quantityText.replace(/\d+/, "").trim();

        this.initialQuantity = this.counterNumber;
        this.originalIngredients = this.parseIngredients();

        this.increaseButton.addEventListener("click", () =>
          this.updateCounter(1)
        );
        this.decreaseButton.addEventListener("click", () =>
          this.updateCounter(-1)
        );

        this.updateDisplay();
      }

      parseIngredients() {
        const ingredients = [];

        // Parse desktop ingredient list
        if (this.ingredientListElement) {
          const ingredientParagraphs = Array.from(
            this.ingredientListElement.querySelectorAll("p")
          );

          ingredientParagraphs.forEach((paragraph) => {
            const lines = paragraph.innerHTML.split("<br />");

            const updatedLines = lines.map((line) => {
              return line.replace(
                /(\d+(\.\d+)?)/g,
                '<span class="ingredient-qty">$1</span>'
              );
            });

            paragraph.innerHTML = updatedLines.join("<br />");

            const spans = paragraph.querySelectorAll(".ingredient-qty");
            spans.forEach((span) => {
              const originalQty = parseFloat(span.textContent);
              ingredients.push({ originalQty, span });
            });
          });
        }

        // Parse mobile tab content
        if (this.tabContentElement) {
          const tabPanes = Array.from(
            this.tabContentElement.querySelectorAll(".tab-pane p")
          );

          tabPanes.forEach((paragraph) => {
            const lines = paragraph.innerHTML.split("<br />");

            const updatedLines = lines.map((line) => {
              return line.replace(
                /(\d+(\.\d+)?)/g,
                '<span class="ingredient-qty">$1</span>'
              );
            });

            paragraph.innerHTML = updatedLines.join("<br />");

            const spans = paragraph.querySelectorAll(".ingredient-qty");
            spans.forEach((span) => {
              const originalQty = parseFloat(span.textContent);
              ingredients.push({ originalQty, span });
            });
          });
        }

        return ingredients;
      }

      updateCounter(change) {
        this.counterNumber = Math.max(1, this.counterNumber + change);
        this.updateDisplay();
        this.updateIngredients();
      }

      updateDisplay() {
        this.counterElement.textContent = `${this.counterNumber} ${this.textSuffix}`;
      }

      updateIngredients() {
        this.originalIngredients.forEach(({ originalQty, span }) => {
          if (originalQty !== null) {
            const scaledQty = (
              (originalQty / this.initialQuantity) *
              this.counterNumber
            ).toFixed(2);
            span.textContent = parseFloat(scaledQty); // Remove unnecessary ".00" or trailing zero
          }
        });
      }
    }

    customElements.define("recipe-ingredient-counter", RecipeIngredientCounter);
  }
});
